import Icon from '../components/Icon';

const ViaFerrata = Icon(
  'via-ferrata',
  <>
    <path
      fillRule="evenodd"
      d="M13.528 6.226a2.75 2.75 0 1 1-3.056-4.572 2.75 2.75 0 0 1 3.056 4.572m-.834-3.325a1.25 1.25 0 1 0-1.389 2.079 1.25 1.25 0 0 0 1.39-2.08"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M19.89 19c.17.355.235.75.19 1.14a20 20 0 0 1 3.92-.56v1.5a32.6 32.6 0 0 0-5.73 1 50.2 50.2 0 0 1-10.65 1.7h-.29A39.4 39.4 0 0 1 0 22.9v-1.53c1.75.371 3.52.641 5.3.81a2.2 2.2 0 0 1 .11-1.47l2.81-6.1v-2.44l-2.47 1.4a.75.75 0 0 1-.62.05.7.7 0 0 1-.47-.34L2.51 9.45C1.58 9.31.72 9.15 0 9V7.43c.63.14 1.43.3 2.36.44a2 2 0 0 1 1-1.19A2 2 0 0 1 6 7.54l.52.97L8.1 7.6a2.77 2.77 0 0 1 1.38-.36h4.1a1.24 1.24 0 0 0 1.08-.61l.49-1a2.13 2.13 0 0 1 3.36-.54c.209.202.376.443.49.71q.139.29.17.61a25.4 25.4 0 0 1 4.83-.8v1.5a10 10 0 0 0-1.6.16 13.1 13.1 0 0 1-5.17 6.06v.05zm.63-11.4-1.77.4-1.48 3.42a11.8 11.8 0 0 0 3.25-3.82M3.79 8.69l1.81 3.2 2.99-1.73a.75.75 0 0 1 1.12.65v3l5.42-1.22 2.49-5.74a.62.62 0 0 0 0-.5.64.64 0 0 0-.37-.35.63.63 0 0 0-.75.34l-.5 1a2.79 2.79 0 0 1-2.43 1.39H9.48c-.221 0-.438.06-.63.17l-2.24 1.27a.72.72 0 0 1-.57.07.74.74 0 0 1-.46-.35l-.92-1.63A.53.53 0 0 0 4 8a.5.5 0 0 0-.21.31.5.5 0 0 0 0 .38m2.97 13.16a.67.67 0 0 0 .34.38 1 1 0 0 0 .23.05h.08a.67.67 0 0 0 .59-.35l2.35-4.54a.75.75 0 0 1 .5-.38l4.14-.94a.75.75 0 0 1 .85.42l1.69 3.68a.57.57 0 0 0 1-.1.56.56 0 0 0 0-.44L15.88 14 9.5 15.4l-2.74 5.94a.61.61 0 0 0 0 .51m2.77.33A53 53 0 0 0 16.25 21c-.03 0-.07-.08-.07-.15l-1.44-3.15-3.21.73z"
      clipRule="evenodd"
    />
  </>
);

export default ViaFerrata;
